// LanguageContext.jsx — Korean/English UI toggle (backlog #6).
// The choice persists per device (localStorage) and applies instantly.
// Usage:  const { t, lang, toggleLang } = useLang();
//         t("addToOrder")            -> plain string
//         t("added", 3, "Tofu")      -> function strings take args
import { createContext, useContext, useState } from "react";
import { STRINGS } from "./strings";

const LanguageContext = createContext(null);
const STORAGE_KEY = "sunjin-lang";

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => {
    try {
      const saved = localStorage.getItem(STORAGE_KEY);
      return saved === "ko" ? "ko" : "en";
    } catch {
      return "en";
    }
  });

  function toggleLang() {
    setLang(prev => {
      const next = prev === "en" ? "ko" : "en";
      try { localStorage.setItem(STORAGE_KEY, next); } catch { /* private mode */ }
      return next;
    });
  }

  // t(): falls back to English (then the key itself) so a missing Korean
  // string can never blank out the UI.
  function t(key, ...args) {
    const entry = STRINGS[lang]?.[key] ?? STRINGS.en[key] ?? key;
    return typeof entry === "function" ? entry(...args) : entry;
  }

  return (
    <LanguageContext.Provider value={{ lang, toggleLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLang() {
  return useContext(LanguageContext);
}
